import { initLocationCTAButton } from './_location_cta';

const openForm = () => {
  $('[data-search-form]').addClass('open');
  $('.backdrop').addClass('active');
};

const closeForm = () => {
  $('[data-search-form]').removeClass('open');
  $('.backdrop').removeClass('active');
};

$(document).on('focusin', '[data-search-form]', () => {
  openForm();
});

$(document).on('focusout', '[data-search-form]', (e) => {
  // Don't close if we're just focusing on another element within the form.
  if (!$(e.relatedTarget).closest('[data-search-form]').length) {
    closeForm();
  }
});

$(document).on('click', '[data-cancel-search]', () => {
  closeForm();
});

initLocationCTAButton(openForm, '[data-search-form] [name="location"]');
